// session_token rides on the URL the whole way through the guest exercise flow
// (/camera-permission → /try-demo → /exercise, see each page's navigate call)
// — read live off the current address bar rather than a store, so it never
// drifts from whatever link the patient actually followed.
export function getSessionTokenFromUrl() {
  if (typeof window === 'undefined') {
    return null;
  }
  return new URLSearchParams(window.location.search).get('session_token');
}
